import React, { useState, useEffect } from "react";
import { getStudentIdData } from "../../../../lib/studentchecklistview";

export default function CheklistForProfile({ slug, parent=false }) {
  const [tasklist, setTasklist] = useState([]);

  async function getDatafromCheckList() {
    const tasks = await getStudentIdData(slug);
    console.log("tasks: ", tasks);
    const sortedTasklist = [...tasks].sort((a, b) => a.id - b.id);
    setTasklist(sortedTasklist);
  }

  useEffect(() => {
    getDatafromCheckList();
  }, [setTasklist]);

  return (
    <div className="card-body">
      <div className="row">
        <div className="col-md-12">
          <h4 className="goal_settings_title">Cheklist</h4>
          <div className="wishlist-item mt-5">
            <div className="row table-responsive">
              <table className="table table-striped mb-0 table-hover">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="text-left"
                      style={{ width: "8.33%" }}
                    >
                      Time Frame
                    </th>
                    <th
                      scope="col"
                      className="text-center"
                      style={{ width: "8.33%" }}
                    >
                      Urgency
                    </th>
                    <th
                      scope="col"
                      className="text-center"
                      style={{ width: "41.67%" }}
                    >
                      Task
                    </th>
                    <th
                      scope="col"
                      className="text-center"
                      style={{ width: "8.33%" }}
                    >
                      Date
                    </th>
                    <th
                      scope="col"
                      className="text-center"
                      style={{ width: "8.33%" }}
                    >
                      Done
                    </th>
                    <th
                      scope="col"
                      className="text-center"
                      style={{ width: "8.33%" }}
                    >
                      In Progress
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tasklist
                    ? tasklist.map(function (data) {
                        return (
                          <tr key={data.id}>
                            <td>{`${data.startMonth} - ${data.endMonth}`}</td>
                            <td className="text-center">{data.urgency}</td>
                            <td className="text-left">{data.pname}</td>
                            <td className="text-center">{data.tDate}</td>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={data.isDone}
                                readOnly
                                disabled={parent && true}
                              />
                            </td>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={data.isProgress}
                                readOnly
                                disabled={parent && true}
                              />
                            </td>
                          </tr>
                        );
                      })
                    : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {/* /Plan Type */}
    </div>
  );
}
